import { render, staticRenderFns } from "./RoomAmenitiesModal.vue?vue&type=template&id=2bb6439c&scoped=true&"
import script from "./RoomAmenitiesModal.vue?vue&type=script&lang=js&"
export * from "./RoomAmenitiesModal.vue?vue&type=script&lang=js&"
import style0 from "./RoomAmenitiesModal.vue?vue&type=style&index=0&id=2bb6439c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb6439c",
  null
  
)

export default component.exports